import React, { createContext, useContext, useState, } from 'react';
const SearchContext = createContext(undefined);
// Hook for functional components
export const useSearchContext = () => {
    const context = useContext(SearchContext);
    if (!context) {
        throw new Error('useSearchContext must be used within SearchProvider');
    }
    return context;
};
// HOC wrapper for class components
export const withSearchContext = (Component) => {
    const WrappedComponent = React.forwardRef((props, ref) => {
        const searchContext = useSearchContext();
        return React.createElement(Component, { ...props, ...searchContext, ref: ref });
    });
    WrappedComponent.displayName = `withSearchContext(${Component.displayName || Component.name})`;
    return WrappedComponent;
};
// Provider component
export const SearchProvider = ({ children }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [origSearchTerm, setOrigSearchTerm] = useState('');
    const [spellingSuggestion, setSpellingSuggestion] = useState({ spelling_suggestion: '', url: '' });
    const [activeZone, setActiveZone] = useState('0');
    const [filteredAttrs, setFilteredAttrs] = useState([]);
    const [filteredAttrValues, setFilteredAttrValues] = useState({});
    return (React.createElement(SearchContext.Provider, { value: {
            searchTerm,
            origSearchTerm,
            spellingSuggestion,
            activeZone,
            filteredAttrs,
            filteredAttrValues,
            setSearchTerm,
            setOrigSearchTerm,
            setSpellingSuggestion,
            setActiveZone,
            setFilteredAttrs,
            setFilteredAttrValues,
        } }, children));
};
